/**
 * URL configuration constants for the application
 */

/**
 * Default HealthMatch signup URL
 */
export const DEFAULT_SIGNUP_URL = "https://app.healthmatch.io/signup/363";

/**
 * Main HealthMatch website URL
 */
export const HEALTHMATCH_URL = "https://healthmatch.io";

/**
 * HealthMatch terms page URL
 */
export const HEALTHMATCH_TERMS_URL = "https://healthmatch.io/terms";

/**
 * HealthMatch privacy page URL
 */
export const HEALTHMATCH_PRIVACY_URL = "https://healthmatch.io/privacy";

/**
 * HealthMatch consumer health data privacy policy URL (Washington MHMDA / Nevada SB 370)
 */
export const HEALTHMATCH_CONSUMER_HEALTH_DATA_URL =
  "https://healthmatch.io/privacy/consumer-health-data";
